import loadable from "@loadable/component";
import { useEffect, useState } from "react";
import { debounce } from "throttle-debounce";

import { RemoveScroll } from "react-remove-scroll";
import {
  aiAutomationPathname,
  clientServicesAgreement,
  consultation,
  contractingPathname,
  hirePathname,
  langgraphPathname,
  nexusterms,
  portfolioPathname,
  ragPathname,
  statementOfWork,
} from "../constants";
import { useAppContext } from "../context/ThemeContext";
import WidgetLoader from "../WidgetLoader";

const HeaderComponent = loadable(() => import("./HeaderComponent"));
const HireHeaderComponent = loadable(() => import("./HireHeaderComponent"));
const FooterComponent = loadable(() => import("./FooterComponent"));
const HireFooterComponent = loadable(() => import("./HireFooterComponent"));

function Layout({
  children,
  profileName,
  isHomePage,
  openAIWidget,
  setOpenAiWidget,
  isRag,
}) {
  const pathName = window.location.pathname;
  const { siteTheme, state } = useAppContext();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isSafari = /^((?!chrome|android|crios|fxios|edg|opr).)*safari/i.test(
    navigator.userAgent
  );

  useEffect(() => {
    const handleResize = debounce(200, () => {
      setWindowWidth(window.innerWidth);
    });

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let isDay = state.isDay;
  if (JSON.parse(sessionStorage.getItem("isDay"))) {
    isDay = JSON.parse(sessionStorage.getItem("isDay"));
  }

  if (
    pathName.includes(hirePathname) ||
    pathName.includes(contractingPathname) ||
    pathName.includes(nexusterms) ||
    pathName.includes(consultation) ||
    pathName?.includes(clientServicesAgreement) ||
    pathName?.includes(statementOfWork) ||
    pathName.includes(portfolioPathname) ||
    pathName.includes(ragPathname) ||
    pathName.includes(langgraphPathname) ||
    pathName.includes(aiAutomationPathname)
  ) {
    return (
      <div className="relative mx-auto">
        {!isRag && (
          <HireHeaderComponent
            isDay={isDay}
            siteTheme={siteTheme}
            profileName={profileName}
            windowWidth={windowWidth}
            isPortfolio={pathName.includes(portfolioPathname)}
          />
        )}
        <div className={[siteTheme?.background, siteTheme.textColor].join(" ")}>
          {children}
        </div>
        <HireFooterComponent siteTheme={siteTheme} isRag={isRag} />
      </div>
    );
  }

  return (
    <div className="mx-auto relative no-scrollbar ">
      <HeaderComponent
        isHomePage={isHomePage}
        siteTheme={siteTheme}
        isDay={isDay}
        windowWidth={windowWidth}
      />
      <div className={[siteTheme?.background, siteTheme.textColor].join(" ")}>
        {children}
      </div>
      {openAIWidget && (
        <RemoveScroll>
          <WidgetLoader
            containerId="bere-plus--widget-container"
            widgetProps={{
              classNames: `${
                isSafari
                  ? "h-[100vh] pb-1"
                  : "h-[100dvh] pb-[calc(env(safe-area-inset-bottom)+0.75rem)]"
              } w-full sm:w-[80%] max-w-[550px] px-1 flex items-end`,
              wrapperClassnames:
                "w-full h-full bg-black/80 flex justify-end relative",
              iconClassnames:
                "w-6 h-6 absolute top-6 sm:top-5 left-0 ml-2 mt-10 sm:ml-4 sm:mt-2 text-white/50 z-10 cursor-pointer hover:text-white/30 transition-all duration-300",
              onclick: () => setOpenAiWidget(false),
              user: {
                id: "12345",
                intent: "curious",
                plan: "pro",
              },
            }}
          />
        </RemoveScroll>
      )}
      <FooterComponent
        siteTheme={siteTheme}
        openAIWidget={openAIWidget}
        setOpenAiWidget={setOpenAiWidget}
      />
    </div>
  );
}

export default Layout;
